var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#D0F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6655 14.1844C23.6655 17.6 20.9051 20.3689 17.5 20.3689C14.0949 20.3689 11.3345 17.6 11.3345 14.1844C11.3345 10.7689 14.0949 8 17.5 8C20.9051 8 23.6655 10.7689 23.6655 14.1844ZM28 28C27.2956 24.2419 22.8645 21.3454 17.5 21.3454C12.1355 21.3454 7.70438 24.2419 7 28H28Z",
    fill: "#0191D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profilePic.951d449419050aa0e2b9073d8cc827f6.svg";
export { ForwardRef as ReactComponent };